export default "__VITE_ASSET__B7uhw1NY__"